import React from 'react';

import {
  autoUpdate,
  flip,
  offset,
  shift,
  useFloating,
  FloatingPortal,
  arrow,
  FloatingArrow,
  FloatingOverlay,
} from '@floating-ui/react';
import cx from 'classnames';

import Button from 'components/shared/Button';
import Text from 'components/shared/Typography/Text';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import s from './useTooltipDialog.module.css';
import * as t from './useTooltipDialog.types';

export const useTooltipDialog = (props: t.Props) => {
  const { isMobile } = useMediaBreakpoints();
  const { message = 'Are you sure you want to do this?', floatingOptions, options } = props;

  const [isOpen, setIsOpen] = React.useState(false);
  const arrowRef = React.useRef(null);
  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    placement: 'top',
    middleware: [
      offset(6),
      flip(),
      shift(),
      arrow({
        element: arrowRef,
      }),
      ...(floatingOptions?.middleware || []),
    ],

    whileElementsMounted: autoUpdate,
  });

  const onCancel = () => {
    setIsOpen(false);
    props.onCancel?.();
  };

  const TooltipDialog = () => {
    if (!isOpen) return null;

    return (
      <FloatingPortal>
        <FloatingOverlay onClick={onCancel} className={s.tooltipOverlay} />
        <div ref={refs.setFloating} style={floatingStyles} className={cx(s.tooltipFloating, props.containerClassName)}>
          <div className={cx(s.tooltipWrapper, props.tooltipWrapperClass)}>
            <Text className={s.tooltipMessage} size={isMobile ? 'medium' : 'small'} type="brandon" isStrong>
              {message}
            </Text>

            <div className={s.divider} />

            <div className={s.tooltipFooter}>
              {options.map((option, index) => {
                console.log('option.isFlex', option.isFlex);

                const onClickVariant = () => {
                  setIsOpen(false);
                  option.onClick?.();
                };
                return (
                  <Button
                    key={index}
                    type="default"
                    size="small"
                    onClick={onClickVariant}
                    className={cx(s.tooltipBtn, option.isFlex && s.tooltipFlexBtn)}
                  >
                    {option.text}
                  </Button>
                );
              })}
            </div>
          </div>
          <FloatingArrow ref={arrowRef} context={context} fill="white" />
        </div>
      </FloatingPortal>
    );
  };

  return {
    isOpen,
    toggleTooltip: () => setIsOpen(!isOpen),
    openTooltip: () => setIsOpen(true),
    closeTooltip: () => setIsOpen(false),
    setReference: refs.setReference,
    TooltipDialog,
  };
};
